import * as React from "react";
interface IRecoNotification {
    title: string;
    message: string;
    ctaText: string;
    onCtaClick(): void;
    onCloseClick(): void;
}

export class RecoNotification extends React.Component<IRecoNotification> {
    constructor(props: IRecoNotification) {
        super(props);
    }

    render() {
        const { title, message, ctaText, onCtaClick,onCloseClick } = this.props;
        return (
            <div className="reco-notification-container">
                <div className="left-section">
                    <span className="glyphicon glyphicon-cloud"></span>
                </div>
                <div className="center-section">
                    <div className="reco-notification-title">{title}</div>
                    <div className="reco-notification-message">{message}</div>
                    <button className="reco-notification-cta" onClick={onCtaClick}>{ctaText}</button>
                </div>
                <div className="right-section">
                    <span className="glyphicon glyphicon-remove" onClick={onCloseClick}></span>
                </div>
            </div>
        )
    }
}